import React, { useMemo } from 'react'
import { styled } from '@mui/system'
import { Box, Typography } from '@mui/material'
import { store } from '../../constants/store'
import { state } from '../../constants/state'
import { useSearchParams } from 'react-router-dom'

const grey = {
  50: '#F3F6F9',
  100: '#E7EBF0',
  200: '#E0E3E7',
  300: '#CDD2D7',
  400: '#B2BAC2',
  500: '#A0AAB4',
  600: '#6F7E8C',
  700: '#3E5060',
  800: '#2D3843',
  900: '#1A2027',
}

const Root = styled('div')(
  ({ theme }) => `
  table {
    font-family: IBM Plex Sans, sans-serif;
    font-size: 0.875rem;
    border-collapse: collapse;
    width: 100%;
  }

  td,
  th {
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
    text-align: center;
    padding: 6px;
  }

  th {
    background-color: #dcddde
  }
  `
)

export const StoreTable = () => {
  const [searchParams] = useSearchParams()
  const location = searchParams.get('location') ?? 'JHR'

  const storeFiltered = useMemo(() => {
    const array = store.filter((item) => {
      if (item.state === state[location]) {
        return true
      }
    })
    return array
  }, [location])

  //   const stockData = stockListRes?.data ?? [];
  return (
    <Box pt={5} pb={10} px={1}>
      <Box display='flex' justifyContent='center' mb={3}>
        <Typography variant='h5' style={{ fontWeight: 'bold', fontSize: '22px' }}>
          {state[location]}
        </Typography>
      </Box>
      <Box display='flex' justifyContent='center'>
        <Root sx={{ width: 1100, maxWidth: '100%' }}>
          <table aria-label='stock-table'>
            <thead>
              <tr style={{ height: 60 }}>
                <th>Workshop</th>
                <th>Address</th>
                <th>Contact</th>
              </tr>
            </thead>
            <tbody>
              {storeFiltered?.map((row, idx) => (
                <tr key={idx}>
                  <td>{row.dealer}</td>
                  <td style={{ height: 80 }} align='right'>
                    {row.address}
                  </td>
                  <td style={{ height: 80 }} align='right'>
                    {row.phone}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Root>
      </Box>
    </Box>
  )
}
